import type { TenantWithMarketInfo } from '@paulownia/shared';
import { MerchantCard } from './MerchantCard';

interface MerchantGridProps {
  tenants: TenantWithMarketInfo[];
  marketId?: string;
}

/**
 * Responsive grid displaying merchants at a market
 */
export function MerchantGrid({ tenants, marketId }: MerchantGridProps) {
  if (tenants.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        Aucun commercant sur ce marche pour le moment.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {tenants.map((tenant) => (
        <MerchantCard key={tenant.id} tenant={tenant} marketId={marketId} />
      ))}
    </div>
  );
}
